import http from '@/service/http'
import findIndex from 'lodash/findIndex'

const save = async (context, obj) => {
  const { verb, chats } = obj
  const response = await http[verb]('/chats', chats)

  if (response !== null) {
    chats.id = response.data.data.id
    update(context, { ...chats })
    return Promise.resolve()
  }
}

const fetchOne = async ({ commit }, id) => {
  const response = await http.get(`/chats/${id}`)
  if (response !== null) {
    commit('SET_LIST', response.data)
  }
}

const fetch = async ({ commit }) => {
  const response = await http.get('/chats')
  if (response !== null) {
    const chats = response.data
    commit('SET_LIST', chats)
  }
}

const update = ({ commit, state }, obj) => {
  const index = findIndex(state.list, { id: obj.id })
  const payload = { chats: obj, index }
  commit('SET_ONE', payload)
}

const remove = ({ commit, state }, obj) => {
  return new Promise(async (resolve) => {
    const { id } = obj
    const response = await http.delete(`/chats/${id}`)
    const message = response.data.data
    const index = findIndex(state.list, { id })

    if (index > -1) {
      commit('REMOVE_ONE', { index })
    }

    resolve(message)
  })
}

export default {
  fetch,
  fetchOne,
  save,
  update,
  remove
}



// WEBPACK FOOTER //
// ./src/features/admin/chats/store/actions.js